<template>
  <layout-page :nav-bar-show-logo-text="false">
    <page-breadcrumb :hierarchy="breadCrumbs"/>

    <div class="container" v-if="!success">
      <h1
        class="font-large mb-4 text-2xl font-extrabold text-blue lg:text-left lg:text-3xl"
      >
        We'll find the right recruitment agencies for you
      </h1>
      <div class="flex flex-col gap-2 text-grey-90">
        <p>
          Agency Central is the easy way to find a recruitment agency for your
          industry and location.
        </p>
        <p>
          Use our <span class="font-bold">free Agency Finder service</span> and
          we'll search our database of more than 8,000 agencies to identify the
          right recruiters for your needs.
        </p>
        <p>
          Simply fill in our confidential form below, and we'll ask up to three
          recruitment agencies that specialise in your requirement to contact
          you directly.
        </p>
      </div>

      <EmployerDetailsForm
        :submitting="submitting"
        :errors="errors"
        :job-title="parameters.jobTitle"
        :job-location="parameters.jobLocation"
        :employment-type="parameters.employmentType"
        :previous-agencies="parameters.previousAgencies"
        :enquiry="parameters.enquiry"
        :company-name="parameters.companyName"
        :email="parameters.email"
        :contact-name="parameters.contactName"
        :phone-number="parameters.phoneNumber"
        @changeParameter="(payload) => setParameter(payload)"
        @submit="submitEmployerDetailsForm"
      />
    </div>

    <div class="container" v-else>
      <h1
        class="font-large mb-4 text-2xl font-extrabold text-blue lg:text-left lg:text-3xl"
      >
        Success!
      </h1>
      <AcCard class="mb-4 bg-green-10 p-4 text-lg font-bold text-white">
        Thank You - Your details have been submitted to Agency Central
      </AcCard>

      <static-search-link :to="{ name: 'home' }">
        <InputButton styleType="primary">Return to Homepage</InputButton>
      </static-search-link>
    </div>
  </layout-page>
</template>

<script>
import EmployerDetailsForm from 'Components/FormEmployerDetails.vue';
import IconChevronRight from 'Components/Icons/IconChevronRight.vue';
import LayoutPage from 'Components/layouts/LayoutPage.vue';
import PageBreadcrumb from 'Components/PageBreadcrumb.vue';
import InputButton from 'Components/InputButton.vue';
import StaticSearchLink from '../components/StaticSearchLink.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import AcCard from 'Components/AcCard.vue';

export default {
  name: 'EmployerDetails',
  components: {
    AcCard,
    PageBreadcrumb,
    InputButton,
    LayoutPage,
    IconChevronRight,
    EmployerDetailsForm,
    StaticSearchLink,
  },
  computed: {
    ...mapState('employerDetails', [
      'parameters',
      'submitting',
      'errors',
      'success',
    ]),
    breadCrumbs : function(){
      return [
        {
          name: 'Employer Details Form'
        }
      ]
    }
  },
  methods: {
    ...mapActions('employerDetails', ['submitEmployerDetailsForm']),
    ...mapMutations('employerDetails', ['setParameter', 'resetState']),
  },
  mounted() {
    this.resetState();
  },
};
</script>
